import React, { useCallback, useEffect, useState, useRef } from 'react'
import { useHistory } from 'react-router-dom';
import { useForm } from '../forms/useForm';
import { usePagination } from '../pagination/usePagination';
import { sendRequest } from '../requests/useRequest';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { validarSesion } from '../tokens/useToken';
import { saveUpdateConfiguration } from '../../services/users/configurationUser'
import * as XLSX from 'xlsx';



export const useUser = () => {

    const history = useHistory();
    const numberItems = 10;

    // ? URL
    let url_helen = localStorage.getItem('url_helen');

    const _active_micro =
        localStorage.getItem("active_microsanitary")?.toLowerCase() === "true";

    const _interfaced_hospital =
        localStorage.getItem("interfaced")?.toLowerCase() === "true";

    // ? CONFIGURATIION DIALOG
    const [modalTitle, setModalTitle] = useState(false);
    const [modalUser, setModalUser] = useState(false);
    const [modalCard, setModalCard] = useState(false);
    const [methodUser, setMethodUser] = useState("");
    const [modalTitleSection, setModalTitleSection] = useState(false)
    const [modalSection, setModalSection] = useState(false);
    const [typeModal, setTypeModal] = useState("typeSection")
    const [typeCard, setTypeCard] = useState("typeCard")
    const [typeCedula, setTypeCedula] = useState("typeCedula")
    const [modalTitleCard, setModalTitleCard] = useState(false)

    // ? LIST USERS
    const [listUsers, setListUsers] = useState([]);
    const [listUsersSearch, setListUsersSearch] = useState([]);
    const [userId, setUserId] = useState(0);
    const [listRol, setListRol] = useState([]);
    const [loading, setLoading] = useState(false);

    const [listDepartament, setListDepartament] = useState([])
    const [listDepa, setListDepa] = useState([])
    const [imagen, setImagen] = useState("")

    // ? CONFIGURATION SECTION
    const [modalTitleSection2, setModalTitleSection2] = useState(false);
    const [modalSection2, setModalSection2] = useState(false);
    const [typeModalSection, setTypeModalSection] = useState("viewSection");
    const [dataSections, setDataSections] = useState([]);
    const [check, setCheck] = useState('false')
    const [departament, setDepartament] = useState([]);
    const [section, sectionSet] = useState([])
    const [tree, setTree] = useState([])
    const treeviewRef = useRef(null);
    const [processes, setProcesses] = useState([]);
    const [listSect, setListSect] = useState([]);
    const [sectionSelected, setSectionSelected] = useState([]);
    const [selected, setSelected] = useState([]);


    // ? CONFIGURATION CEDULA
    const [modalCedula, setModalCedula] = useState(false);
    const [data, setData] = useState([]);

    //? TOAST ALERT 
    const [showToast, setShowToast] = useState(false);
    const [toastType, setToastType] = useState("info");
    const [toastTitle, setToastTitle] = useState("");
    const [toastMessage, setToastMessage] = useState("");


    //? CUSTOM ALERT GLOBAL
    const [customAlert, setCustomAlert] = useState({
        visible: false,
        mode: "alert",
        type: "info",
        title: "",
        message: "",
        onAccept: null,
        onCancel: null
    });

    const [savedCardCode, setSavedCardCode] = useState("");

    const [validationsCard, setValidationsCard] = useState({
        card_code: false,
        id_departaments: false,
        section: false
    });

    // ? PERMISSION CONFIGURATION
    const [modalConfiguration, setModalConfiguration] = useState(false);
    const [loadingConfiguration, setLoadingConfiguration] = useState(false)
    const [isAdminLoggedUser, setIsAdminLoggedUser] = useState(false);
    const basePermissions = [
        {
            key: "IS_ADMIN",
            label: "Activación de convenios",
            description: "Autorización y gestión de convenios en el punto de venta.",
            icon: "fa fa-link",
            enabled: true
        },
        {
            key: "AUTHORIZE_CASH",
            label: "Cortes de caja",
            description: "Autorización y gestión de cierres de caja extemporáneos.",
            icon: "fa fa-money",
            enabled: false
        },
        {
            key: "AUTHORIZE_CANCELLATION",
            label: "Cancelación de ordenes",
            description: "Autorización de cancelaciones de órdenes de trabajo.",
            icon: "fa fa-ban",
            enabled: true
        },

        {
            key: "AUTHORIZED_SANITARY",
            label: "Modificación de muestras",
            description: "Permite agregar determinaciones a las muestras.",
            icon: "icofont icofont-tablets",
            enabled: false
        },
        {
            key: "AUTHORIZE_EDITION",
            label: "Edición de Datos",
            description: "Edición de los registros de pacientes.",
            icon: "pi pi-user-edit",
            enabled: false
        },
        {
            key: "AUTHORIZE_MOVEMENT",
            label: "Rectificación de Método de Pago",
            description: "Permite a usuarios autorizados modificar la forma de pago de una orden ya confirmada.",
            icon: "pi pi-credit-card",
            enabled: false
        },
        {
            key: "AUTHORIZE_SERVICE",
            label: "Rectificación de Tipo de Servicio",
            description: "Permite a usuarios modificar el tipo de servicio en la orden ya confirmada.",
            icon: "pi pi-cog",
            enabled: false
        },
        {
            key: "AUTHORIZE_MICROSITE",
            label: "Personalización del micrositio",
            description: "Permite administrar las imágenes utilizadas en el inicio de sesión del micrositio de empresas y doctores.",
            icon: "icofont icofont-file-exe",
            enabled: false
        },
        {
            key: "AUTHORIZE_SELLER",
            label: "Transferir cartera de clientes",
            description: "Permite transferir clientes de un vendedor a otro.",
            icon: "icofont icofont-folder-search",
            enabled: false
        },
        {
            key: "AUTHORIZE_PATIENT",
            label: "Homologar pacientes",
            description: "Permite combinar información de pacientes repetidos.",
            icon: "icofont icofont-job-search",
            enabled: false
        },

    ];

    //#region ALERT GLOBAL 
    const showToastAlert = (
        type = "info",
        title = "",
        message = ""
    ) => {

        setToastType(type);
        setToastTitle(title);
        setToastMessage(message);
        setShowToast(true);

    };

    const closeToastAlert = () => {

        setShowToast(false);
        setToastTitle("");
        setToastMessage("");

    };
    //#endregion

    //#region CUSTOM ALERT

    const showCustomAlert = (type, title, message) => {

        console.log("🚨 showCustomAlert ejecutado");

        setCustomAlert({
            visible: true,
            mode: "alert",
            type,
            title,
            message,
            onAccept: () => {
                setCustomAlert(prev => ({
                    ...prev,
                    visible: false
                }));
            },
            onCancel: null
        });

    };

    const showCustomAlertConfirm = ({
        type = "warning",
        title,
        message,
        buttonText = "Aceptar",
        cancelText = "Cancelar"
    }) => {

        return new Promise((resolve) => {

            setCustomAlert({
                visible: true,
                mode: "confirm",
                type,
                title,
                message,
                buttonText,
                cancelText,

                onAccept: () => {

                    setCustomAlert(prev => ({
                        ...prev,
                        visible: false
                    }));

                    resolve(true);

                },

                onCancel: () => {

                    setCustomAlert(prev => ({
                        ...prev,
                        visible: false
                    }));

                    resolve(false);

                }

            });

        });

    };
    //#endregion




    // ? EXCLUDED
    const [permissions, setPermissions] = useState(() => {

        return basePermissions.filter(permission => {

            if (permission.key === "AUTHORIZED_SANITARY" && !_active_micro) {
                return false;
            }

            if (permission.key === "AUTHORIZE_DETERMINATIONS" && !_active_micro) {
                return false;
            }

            if (permission.key === "AUTHORIZE_SERVICE" && !_interfaced_hospital) {
                return false;
            }

            return true;
        });

    });

    const permissionOptions = [
        { label: "Inactivo", value: false },
        { label: "Activo", value: true }
    ];


    // ? TOGGLE
    const toggleUser = () => {
        setModalUser(!modalUser);
    }

    const toggleCard = () => {

        setValidationsCard({
            card_code: false,
            id_departaments: false,
            section: false
        });

        setModalCard(prev => !prev);
    };

    const toggleSection = () => {
        setModalSection(!modalSection)
    }

    const toggleSection2 = () => {
        setModalSection2(!modalSection2)
    }

    const toggleCedula = () => {
        setModalCedula(!modalCedula);
    };


    // ? CONFIGURAYION PERMISSIONS
    const togglePermission = (key, value) => {
        setPermissions(prev =>
            prev.map(p =>
                p.key === key
                    ? { ...p, enabled: value }
                    : p
            )
        );
    };

    const toggleConfiguration = () => {
        setModalConfiguration(!modalConfiguration);
    };

    const [formUser, handleInputChange, reset, handleUpdateValues, handleSelectValues] = useForm({
        name_user: "",
        listRoles: [],
        listSection: [],
        card_code: "",
        id_departaments: [],
        listSections: [],
        checkSection: false,
    });

    const { name_user, listRoles, listSection, card_code, id_departaments, listSections, checkSection } = formUser;

    const [validationsUser, setValidationsUser] = useState({
        listRoles_valid: false
    });




    const [formValuesC, handleInputChangeC, , handleUpdateValuesC] = useForm({
        professional_license: "",

    });

    const { professional_license } = formValuesC;

    //DEPARTAMENT
    const [formValuesT, handleInputChangeT, , handleUpdateValuesT, handleSelectValuesT] = useForm({
        id_departament: "",
    });

    const { id_departament } = formValuesT;



    // * CONFIGURATION TO SHOW SETTINGS BUTTON ONLY IF THE LOGGED USER IS ADMIN
    useEffect(() => {
        const usernameLogged = localStorage.getItem("username");

        if (!usernameLogged || !listUsersSearch?.length) return;

        const loggedUser = listUsersSearch.find(
            user => user.username === usernameLogged
        );

        const adminRoles = ["ADMINISTADOR", "ADMINISTRADOR"];

        setIsAdminLoggedUser(
            loggedUser?.array_roles?.some(role => adminRoles.includes(role)) ?? false
        );
    }, [listUsersSearch]);


    const handleSearchUser = (e) => {
        const busqueda = e.target.value.toUpperCase();

        const filtered = listUsersSearch.filter(obj =>
            obj.name.toUpperCase().includes(busqueda) ||
            obj.username.toUpperCase().includes(busqueda)
        );

        setListUsers(filtered);
    };


    const handleGetUsersRoles = useCallback(async () => {
        setLoading(true);
        let listTmp = await handleRequest("GET", "Users", "Usuarios");
        if (listTmp !== null && listTmp.length > 0) {
            setLoading(false);
            let list = [];

            let startItems = 0;
            let endItems = numberItems;
            let aux = numberItems * currentPage;

            endItems = aux;
            startItems = endItems - numberItems;

            listTmp.forEach((obj, index) => {
                let posicion = index + 1;
                let visibleTable = false;

                if (posicion > startItems && posicion <= endItems) {
                    visibleTable = true;
                }

                let array_roles = [];
                let name_roles;

                if (obj.roles !== undefined && obj.roles !== null) {
                    name_roles = [];
                    obj.roles.forEach(r => {
                        name_roles.push(
                            [r]
                        );
                        array_roles.push(r);
                    })
                }
                else {
                    name_roles = "Sin roles asignados"
                }

                let array_IDroles = [];
                let id_roles;

                if (obj.ids_roles !== undefined && obj.ids_roles !== null) {
                    id_roles = [];

                    obj.ids_roles.forEach(element => {

                        id_roles.push(
                            [element]
                        );
                        array_IDroles.push(element)
                    });
                }
                else {
                    id_roles = 0
                }

                list.push({
                    id_user: obj.id_user,
                    name: obj.name + " " + obj.paternal_surname + " " + obj.maternal_surname,
                    name_user: obj.name,
                    paternal_surname: obj.paternal_surname,
                    maternal_surname: obj.maternal_surname,
                    username: obj.username,
                    id_helen_users: obj.id_helen_users,
                    id_external: obj.id_external,
                    job: obj.job,
                    card_code: obj.card_code,
                    areas: obj.areas,
                    array_roles: array_roles,
                    name_roles: name_roles,
                    ids_roles: obj.ids_roles,
                    ids_sections: obj.ids_sections,
                    sections: obj.sections,
                    professional_license: obj.professional_license,
                    configuration: obj.configuration,

                    visibleTable: visibleTable
                });
            });
            setListUsers(list);
            setListUsersSearch(list);
        }

    }, [history]);

    const handleGetRoles = async () => {

        let listTmp = await handleRequest("GET", "Roles/List", "Roles");

        if (listTmp !== null && listTmp.length > 0) {

            let list = [];
            listTmp.forEach(obj => {
                list.push({
                    value: obj.id_role,
                    label: obj.name
                });
            });

            setListRol(list);
        }
    }

    const handleUpdate = (id_user) => {
        let findUser = listUsersSearch.find(x => x.id_user === parseInt(id_user));

        if (findUser) {

            let listRolesUser = [];

            if (typeof findUser.name_roles === "string") {
                listRolesUser = [];
            }
            else {
                findUser.ids_roles.forEach((obj, index) => {


                    listRolesUser.push({
                        value: obj,
                        label: findUser.name_roles[index]
                    })
                });
            }

            handleUpdateValues({
                name_user: findUser.name,
                listRoles: listRolesUser
            });

            setUserId(id_user);
            handleGetRoles();
            setMethodUser("update_roles");
            setModalTitle("Editar usuario");
            toggleUser();
        }
    }

    const handleListSectionsCard = (id_user) => {
        let findUser = listUsersSearch.find(x => x.id_user === parseInt(id_user));
        if (findUser) {
            let listSectionsUser = [];
            findUser.ids_sections.forEach((section, indexSection) => {
                if (findUser.sections[indexSection] !== undefined) {
                    ////console.log(indexSection);
                    listSectionsUser.push({
                        value: section,
                        label: findUser.sections[indexSection],
                    });
                }
            });

            handleUpdateValues({
                listSections: listSectionsUser,
                name_user: findUser.name,

            });
            handleGetSections();
            setUserId(id_user);

        }
    }

    const getCardCode = async (id_user, name_user) => {
        console.log("🚀 ~ getCardCode ~ name_user:", name_user)
        setSavedCardCode("");

        handleUpdateValues({
            name_user: name_user,
            card_code: "",
            id_departaments: []

        });
        let _find = formUser.card_code
        let listTmp = await handleRequest("GET", `AccessUser/${id_user}`);
        if (listTmp === null) {
        }
        else {
            let data1 = data;
            if (listTmp && listTmp.length > 0) {
                const data = listTmp[0];
                setSavedCardCode(String(data.card_code ?? ""));
                const dataSection = new Set();
                const uniqueSectionsMap = {};
                const dataDepartament = []
                const listTmpDepartament = []


                for (let id of data.id_section) {
                    const section1 = data1.find(sec => sec.id_section === id);
                    if (section1 && !uniqueSectionsMap[section1.id_section]) {
                        uniqueSectionsMap[section1.id_section] = true;
                        dataSection.add({
                            id_section: section1.id_section,
                            name: section1.label,
                            checkSection: true
                        });
                    }
                }

                data1.forEach(section => {
                    if (!uniqueSectionsMap[section.id_section]) {
                        dataSection.add({
                            id_section: section.id_section,
                            name: section.label,
                            checkSection: false
                        });
                    }
                });

                const uniqueSections = Array.from(dataSection);
                sectionSet(uniqueSections);



                departament.forEach(departament => {
                    listTmpDepartament.push({
                        value: departament.id_departament,
                        label: departament.name
                    })
                })

                const listDepartament = [];
                const idDepartments = listTmp[0].id_departament;
                if (Array.isArray(idDepartments)) {
                    idDepartments.forEach(id => {
                        const newDepartament = departament.find(departament => departament.id_departament === id);
                        if (newDepartament) {
                            listDepartament.push({
                                value: newDepartament.id_departament,
                                label: newDepartament.name
                            });
                        }
                    });
                } else {
                    const newDepartament = departament.find(departament => departament.id_departament === idDepartments);
                    if (newDepartament) {
                        listDepartament.push({
                            value: newDepartament.id_departament,
                            label: newDepartament.name
                        });
                    }
                }

                setListDepa(listDepartament);

                const departament1 = departament.find(dep => dep.id_departament === data.id_departament[0]);
                if (departament1) {
                    dataDepartament.push({
                        value: departament1.id_departament,
                        label: departament1.name
                    });
                }

                handleUpdateValues({
                    name_user: name_user,
                    listRoles: data.listRoles,
                    listSection: data.id_section,
                    card_code: data.card_code,
                    id_departaments: listDepartament,
                    listSections: dataSection
                });
                setListDepa([...listDepartament]);
                sectionSet([...dataSection]);
            }
        }
    }


    const saveCardCode = async () => {

        const findUser = listUsersSearch.find(
            x => x.id_user === parseInt(userId)
        );

        const code = String(card_code ?? "").trim();

        const departments = Array.isArray(id_departaments)
            ? id_departaments
            : [];

        const selectedSections = Array.isArray(section)
            ? section.filter(obj => obj.checkSection === true)
            : [];

        // VALIDACIONES
        const hasCode = code.length > 0;
        const validCode = /^\d{4}$/.test(code);

        const newValidations = {
            card_code: hasCode && !validCode,
            id_departaments: hasCode && departments.length === 0,
            section: false
        };

        setValidationsCard(newValidations);

        // No intentar guardar si falta algún campo
        if (Object.values(newValidations).some(value => value)) {
            return;
        }

        if (!findUser) {
            showToastAlert(
                "error",
                "Usuario no encontrado",
                "No se encontró el usuario seleccionado."
            );
            return;
        }

        const newForm = {
            id_user: findUser.id_user,
            card_code: hasCode ? code : "",
            id_section: selectedSections.map(obj => obj.id_section),
            id_departament: hasCode ? departments.map(obj => obj.value) : []
        };

        setLoading(true);

        try {
            const listTmp = await handleRequest(
                "POST",
                "AccessUser",
                "información Autorizada",
                newForm
            );

            if (listTmp === null) {
                return;
            }

            showToastAlert("success", "", "Información actualizada");

            handleUpdateValues({
                id_user: 0,
                card_code: "",
                listSections: [],
                id_departaments: []
            });

            setSavedCardCode("");
            setListDepa([]);
            sectionSet([]);

            setValidationsCard({
                card_code: false,
                id_departaments: false,
                section: false
            });

            toggleCard();

        } catch (error) {
            console.error("Error al guardar la información:", error);

            showToastAlert(
                "error",
                "Error al guardar",
                "No fue posible guardar la infromación. Inténtalo nuevamente."
            );

        } finally {
            setLoading(false);
        }
    };

    const saveUpdatePatient = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (handleValidationsUser()) {
            setLoading(false);
            return;
        }

        let ids_roles = [];

        formUser.listRoles.forEach(obj => {
            ids_roles.push(obj.value);
        });


        let body = {
            id_user: userId,
            ids_roles: ids_roles
        };

        let listTmp = await handleRequest("PUT", 'Users/AssingRoles', 'Roles', body);

        if (listTmp !== null) {
            setUserId(0);
            setLoading(false);
            toggleUser();
            handleGetUsersRoles();
            showToastAlert("success", "", "Usuario actualizado");
        }
    }

    const handleListSection = (id_user) => {
        let findUser = listUsersSearch.find(x => x.id_user === parseInt(id_user));
        if (findUser) {
            let listSectionsUser = [];
            findUser.ids_sections.forEach((section, indexSection) => {
                if (findUser.sections[indexSection] !== undefined) {
                    listSectionsUser.push({
                        value: section,
                        label: findUser.sections[indexSection],
                    });
                }
            });

            handleUpdateValues({
                name_user: findUser.name,
                listSection: listSectionsUser
            });

            setTypeModal("typeSection");
            setModalTitleSection("Secciones/Áreas")
            toggleSection();
            getSection(); toggleSection();
            getSection();
            getSection();
            setSelected([]);
            setId(id_user);
            handleGetSections();
            setUserId(id_user);
        }
    }


    const handleCheckboxChange = (e) => {
        const isChecked = e.target.checked;
        setCheck(isChecked);
        checkbox(isChecked);
    };

    const checkbox = async (isChecked) => {
        if (isChecked) {
            getDepartaments()
        } else {
        }
    };

    const handleListCard = (id_user) => {
        setTypeCard("typeCard");
        let findUser = listUsersSearch.find(x => x.id_user === parseInt(id_user));
        console.log("🚀 ~ handleListCard ~ findUser:", findUser)

        handleSectionUser(id_user);
        setModalTitleCard("Tarjeta de Trazabilidad")
        toggleCard();
        setId(id_user);
        setUserId(id_user);
        getCardCode(id_user, findUser.name)
        getDepartaments()
    }

    const handleListCedula = (id_user) => {
        let findUser = listUsersSearch.find(x => x.id_user === parseInt(id_user));
        if (findUser) {
            setUserId(findUser.id_user);
            handleUpdateValuesC({
                professional_license: findUser.professional_license || ""
            });
        }
        setModalTitleCard("Cédula Profesional");
        toggleCedula();
    };

    const saveProfessionalLicense = async (e) => {
        e.preventDefault();
        setLoading(true);

        let body = {
            id_user: userId,
            professional_license: formValuesC.professional_license
        };

        let listTmp = await handleRequest("PUT", 'Users/UpdateProfessionalLicense', 'Cedula', body);

        handleUpdateValuesC({
            "professional_license": "",
        });

        if (listTmp !== null) {
            showToastAlert("success", "", "Cédula Guardada");
            setLoading(false);
            toggleCedula();
            window.location.reload();
        }
    };


    useEffect(() => {
        getDepartaments()
        getSection()
    }, [history.location]);


    const getDepartaments = async () => {

        let requestOptions = {
            method: 'GET'
        };

        let ListDepartaments = [];
        let listTmpDepartament = []

        const respuesta = await sendRequest(requestOptions, "Departaments/List");
        if (respuesta.code === 200) {
            if (respuesta.data.length >= 1) {
                respuesta.data.forEach((value) => {
                    ListDepartaments.push({
                        id_departament: value.id_departament,
                        id_area: value.id_area,
                        name: value.name,
                    });
                });
                setDepartament(ListDepartaments);
                respuesta.data.forEach((value) => {
                    listTmpDepartament.push({
                        value: value.id_departament,
                        label: value.name
                    })
                })
                setListDepartament(listTmpDepartament)
            }
            else {
                setDepartament([]);
            }
        }
    }


    const onRenderItem = (item, treeview) => {
        return (
            <div className="treeview-animated-element">
                <i className="icofont icofont-microscope-alt f-12"></i> {item.name}
            </div>
        )
    }

    const changeTree = (e) => {
        const updatedTree = tree.map(item => {
            if (item.id_section === e.id_section) {
                return {
                    ...item,
                    state: 2,
                    isLeaf: false
                };
            }
            return item;
        });

        setTree(updatedTree);
        treeSection(e)

    }

    const treeSection = async (e) => {
        let a = e
        const api = treeviewRef.current.api
        const items = api.getItems();
        let array = [];

        items.forEach(element => {
            if (element.id_section !== undefined) {
                let pro_aux = [];
                let id = true;
                let checkParent = 1;
                let auxiliar = processes;

                auxiliar.forEach(p => {
                    pro_aux.push({
                        "id_process": p.id_process,
                        "isLeaf": p.id_section,
                        "state": p.id_section === true ? 1 : 2,
                        "name": p.name,
                    })
                })

                array.push({
                    //"children": pro_aux,
                    "id_section": element.id_section,
                    "name": element.name,
                    "isLeaf": id,
                    "state": checkParent
                })
            }
        })

        setTree(array);
    }

    const handleCheckChange = (e, id_section) => {

        const checked = e.target.checked;

        const updatedSections = section.map(item =>
            item.id_section === id_section
                ? { ...item, checkSection: checked }
                : item
        );

        sectionSet(updatedSections);

        handleUpdateValues({
            ...formUser,
            listSections: updatedSections
        });

        setValidationsCard(prev => ({
            ...prev,
            section: false
        }));
    };

    const handleSectionUser = (id_user) => {
        handleGetSections();
        getSection();
        let findUser = listUsersSearch.find(x => x.id_user === parseInt(id_user));
        let sectionsFound = [];
        const userSectionsArray = Object.values(findUser.sections);
        data.forEach(section => {
            if (data != undefined) {
                const count = userSectionsArray.filter(name => name === section.label).length;
                sectionsFound.push({
                    id_section: section.id_section,
                    name: section.label,
                    checkSection: count === 1 ? true : false
                });
            }
        });

        sectionSet(sectionsFound);
        handleUpdateValues({ listSections: sectionsFound }); // Actualiza el estado listSections
    };

    const handleGetSections = async () => {
        let listTmp = await handleRequest("GET", "Section/List/false", "Sectionss");
        if (listTmp !== null && listTmp.length > 0) {
            let list = [];
            let arreglo = [];

            listTmp.forEach(obj => {
                list.push({
                    value: obj.id_section,
                    label: obj.name,
                    check: true,
                    ...obj
                });
                arreglo.push(obj.id_section);
            });
            setListSect(list);
            setSectionSelected(arreglo)
        }
    }

    const onChange = (selected) => {
        setSelected(selected)
    };


    const getSection = async () => {

        let requestOptions = {
            method: 'GET'
        };

        const respuesta = await sendRequest(requestOptions, "Section/List/false");
        ////console.log(respuesta)
        if (respuesta.code === 200) {
            let array = []

            respuesta.data.forEach(element => {

                if (element.is_imagenology) {
                    setImagen("true")

                }
                array.push({
                    "value": element.id_section,
                    "label": element.name,
                    "id": element.id_section,
                    "id_section": element.id_section,
                })
            });

            setData(array);
        }
        else if (respuesta.code === 401) {
        }
        else if (respuesta.code === 500) {
            showToastAlert("error", "Exámen", "Ocurrio un problema en el servidor");
        }
        else {
            showToastAlert("error", "Exámen", respuesta.data.msg);
        }
    }

    const [id, setId] = useState(0)


    const saveUpdateSections = async (e) => {
        e.preventDefault();
        setLoading(true);

        let array2 = []

        formUser.listSection.forEach(obj => {
            array2.push(obj.value);
        });

        let body = {
            id_user: userId,
            ids_sections: array2

        };


        let listTmp = await handleRequest("PUT", 'Users/AssingSections', 'Sections', body);
        if (listTmp !== null) {
            ////console.log("pasa");

            setUserId(0);
            setLoading(false);
            toggleSection();
            handleGetUsersRoles();
            showToastAlert("success", "", "Secciones actualizadas");
        }
    }


    const handleListSections = (id_user) => {

        let findUser = listUsersSearch.find(x => x.id_user === parseInt(id_user));
        setDataSections(findUser.sections)
        setTypeModalSection("viewSection");
        setModalTitleSection2("Secciones");
        toggleSection2();
    }

    // * PAGINATION USER ROLES
    const { totalPageCount, currentPage, nextPage, previousPage, goToPage } = usePagination(listUsers.length, numberItems);

    useEffect(() => {
        let startItems = 0;
        let endItems = numberItems;

        let aux = numberItems * currentPage;

        endItems = aux;
        startItems = endItems - numberItems;

        let listTmp = [];

        listUsers.forEach((data, key) => {
            let posicion = key + 1;
            let visibleTable = false;

            if (posicion > startItems && posicion <= endItems) {
                visibleTable = true;
            }

            listTmp.push({
                ...data,
                visibleTable: visibleTable
            });
        });

        setListUsers(listTmp);

    }, [totalPageCount, currentPage]);


    useEffect(() => {
        handleGetUsersRoles();
    }, [handleGetUsersRoles]);



    const handleValidationsUser = () => {
        let statusValidation = false;
        let newValidations = {};

        if (formUser.listRoles.length === 0) {
            newValidations = {
                ...newValidations,
                listRoles_valid: true
            };

            statusValidation = true;
        }
        else {
            newValidations = {
                ...newValidations,
                listRoles_valid: false
            }
        }

        setValidationsUser(newValidations);
        return statusValidation;
    }

    const permissionMap = Object.fromEntries(
        basePermissions.map(p => [p.key, p.label])
    );

    const getPrivilegesLabels = (configuration) => {
        if (!Array.isArray(configuration) || configuration.length === 0) {
            return "";
        }

        return configuration
            .map(key => permissionMap[key])
            .filter(Boolean)
            .join(", ");
    };

    // ? DOWNLOAD EXCEL
    const exportExcel = () => {
        if (!listUsers || listUsers.length === 0) return;


        const exportData = listUsers.map((user, index) => ({
            "#": index + 1,
            "Nombre": user.name || "",
            "Usuario": user.id_external || "",
            "Privilegios": getPrivilegesLabels(user.configuration),

            "Cédula Profesional": user.professional_license || "",
            "Roles": user.array_roles ? user.array_roles.join(", ") : "",
            "Secciones": user.sections ? user.sections.join(", ") : "",
        }));

        const worksheet = XLSX.utils.json_to_sheet(exportData);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Usuarios');

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const dataBlob = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        const fileName = `Usuarios.xlsx`;
        const url = window.URL.createObjectURL(dataBlob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };


    const handleConfiguration = (id_user) => {
        const findUser = listUsersSearch.find(
            x => x?.id_user === parseInt(id_user)
        );

        if (!findUser) return;

        setUserId(findUser.id_user);

        setPermissions(prevPermissions =>
            prevPermissions.map(permission => ({
                ...permission,
                enabled: findUser?.configuration?.includes(permission.key) || false
            }))
        );

        setModalTitleCard("Configuración de permisos");
        toggleConfiguration();
        handleUpdateValues({
            name_user: findUser.name,
        });

    };

    // ? SAVE CONFIGURATION
    const saveConfiguration = async () => {
        setLoadingConfiguration(true);

        const response = await saveUpdateConfiguration({
            "id_user": userId ?? 0,
            "permissions": permissions ?? []
        });

        if (response.code === 200) {
            const activeConfigurations = permissions
                .filter(p => p.enabled)
                .map(p => p.key);

            updateUserConfigurationInList(userId, activeConfigurations);
            toggleConfiguration();
            showToastAlert("success", "Usuario", "Configuración actualizada");
            setLoadingConfiguration(false);
        }
        else {
            showToastAlert("error", "Usuario", "Error al actualizar la configuración");
        }
    }


    // ? UPDATE DATE
    const updateUserConfigurationInList = (id_user, activeConfigurations) => {
        setListUsersSearch(prev =>
            prev.map(user => {
                if (user?.id_user !== id_user) return user;

                return {
                    ...user,
                    configuration: activeConfigurations
                };
            })
        );
    };


    // * GLOBAL REQUEST
    const handleRequest = async (method, methodUrl, nameMethod, body = null) => {

        let requestOptions = {
            method: method
        };

        if (body !== null) {
            requestOptions = {
                ...requestOptions,
                body: JSON.stringify(body)
            };
        }

        const response = await sendRequest(requestOptions, methodUrl);

        if (response.code === 200) {
            return response.data;
        }
        else if (response.code === 401) {
            validarSesion(history, response.code, handleRequest);
        }

        else {
            showToastAlert("warning", "Tarjeta Rechazada", response.data.msg);
        }

        return null;
    }

    const generateCardCode = async () => {

        const currentCode = String(card_code ?? "").trim();

        if (currentCode !== "") {

            const confirmed = await showCustomAlertConfirm({
                type: "warning",
                title: "¿Reemplazar código?",
                message: "Este usuario ya tiene un código asignado. ¿Estás seguro de que deseas reemplazarlo por uno nuevo?",
                buttonText: "Sí, reemplazar",
                cancelText: "Cancelar"
            });

            if (!confirmed) return;
        }

        let code;

        do {
            code = String(Math.floor(1000 + Math.random() * 9000));
        } while (code === currentCode);

        handleUpdateValues({
            card_code: code
        });

        setValidationsCard(prev => ({
            ...prev,
            card_code: false
        }));
    };


    const handleCardCodeChange = (e) => {

        const value = e.target.value;

        handleInputChange(e);

        if (!/^\d{4}$/.test(value.trim())) {
            handleUpdateValues({
                id_departaments: []
            });
        }
        setValidationsCard(prev => ({
            ...prev,
            card_code: false,
            id_departaments: false
        }));
    };



    const handleToggleAllSections = () => {

        const currentSections = Array.isArray(section) ? section : [];

        if (currentSections.length === 0) return;

        const allSelected = currentSections.every(
            item => item.checkSection === true
        );

        const updatedSections = currentSections.map(item => ({
            ...item,
            checkSection: !allSelected
        }));

        // Actualizar únicamente los switches
        sectionSet(updatedSections);

        // Conservar todos los demás valores del formulario
        handleUpdateValues({
            ...formUser,
            listSections: updatedSections
        });

        setValidationsCard(prev => ({
            ...prev,
            section: false
        }));
    };



    return {
        modalTitle, modalUser, methodUser, toggleUser, modalCard, toggleCard, modalTitleCard, typeCard,
        checkbox, check, handleCheckboxChange, handleInputChangeT, id_departament, departament,
        handleSectionUser, section, treeviewRef, changeTree, tree, onRenderItem, processes,
        saveCardCode, handleListSectionsCard, card_code, handleInputChange, checkSection, handleCheckChange,
        listDepartament, formUser, id_departaments, listDepa,

        //USERS MODEL 
        listUsers, listRol, loading,
        name_user, listRoles, handleSelectValues,
        validationsUser,
        //USERS METHODS
        handleUpdate, saveUpdatePatient,
        totalPageCount, currentPage, nextPage, previousPage, goToPage,
        handleSearchUser,
        //SECTION   
        handleListSection, handleListCard,
        modalTitleSection, modalSection, toggleSection, typeModal,
        selected, onChange, data, imagen,
        saveUpdateSections,
        //sections
        listSection, listSect,
        //viewa
        modalTitleSection2, modalSection2, typeModalSection, handleListSections, toggleSection2, dataSections, typeCedula,
        sectionSelected, handleListCedula, modalCedula, professional_license, saveProfessionalLicense, handleInputChangeC, formValuesC, toggleCedula,
        url_helen, exportExcel,
        permissions, togglePermission, handleConfiguration,
        modalConfiguration, toggleConfiguration, permissionOptions,
        isAdminLoggedUser, saveConfiguration, loadingConfiguration,

        //?  CUSTOM ALERT DIALOG
        customAlert,

        generateCardCode, validationsCard,

        //? TOAST ALERT
        showToast,
        toastType,
        toastTitle,
        toastMessage,
        showToastAlert,
        closeToastAlert,

        savedCardCode, handleCardCodeChange,
        handleToggleAllSections



    }
}